import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FLOW_PRIORITIZATION, selectFeature } from 'next/entities/features';

import Prioritization from './Prioritization';
import PrioritizationPrompt from './PrioritizationPrompt';

export const PrioritizationGate = ({ id, enabled }) =>
  enabled ? <Prioritization id={id} /> : <PrioritizationPrompt />;

PrioritizationGate.propTypes = {
  id: PropTypes.string,
  enabled: PropTypes.bool,
};

const mapStateToProps = state => ({
  enabled: selectFeature(state, FLOW_PRIORITIZATION),
});

export default connect(mapStateToProps)(PrioritizationGate);
